import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme';

interface InputProps {
  readonly $error?: boolean;
  readonly $customStyles?: string;
}

export const Input = styled.input<InputProps>(
  ({ $error, $customStyles, theme }) => css`
    width: 100%;
    border-radius: 12px;
    border: 1px solid ${$error ? '#FF5B5B' : 'rgba(222, 224, 230, 1)'};
    background-color: #fff;
    height: 56px;
    padding: 0 16px;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: ${theme.colors.text};
    text-align: left;
    direction: ltr;
    position: relative;

    &::placeholder {
      font-size: 16px;
      color: rgba(73, 78, 87, 1);
      white-space: pre-line;
      direction: ltr;
    }

    &:focus,
    &:active {
      outline: none;
    }

    ${darkMode(css`
      background-color: ${darkPalette.surface};
      ${
        !$error &&
        css`
          border-color: ${darkPalette.surface};
        `
      }

      &::placeholder {
        color: ${darkPalette.textTertiary};
      }
    `)}

    ${$customStyles};
  `,
);

export const DomainBtn = styled.button`
  width: auto;
  height: 28px;
  min-width: 90px;
  background-color: transparent;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 100px;
  font-size: 12px;
  line-height: 14.4px;
  color: rgba(132, 132, 132, 1);
  cursor: pointer;
  padding: 6px 15px;
  direction: ltr;

  ${darkMode(css`
    border-color: ${darkPalette.border};
    color: ${darkPalette.textTertiary};
  `)}
`;

export const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  height: 28px;
  gap: 9px;

  @media screen and (max-width: ${({ theme }) => theme?.mobileWidth}px) {
    gap: 5px;
  }
`;
